"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visuallyHiddenClass = exports.separatorClass = exports.sectionTitleClass = exports.chevronClass = exports.keyChipClass = exports.itemKeysClass = exports.itemRightClass = exports.itemDescriptionClass = exports.itemLabelClass = exports.itemMainClass = exports.itemIconClass = exports.itemRowClass = exports.listClass = exports.headerTitleClass = exports.headerClass = exports.paneClass = exports.handleAreaClass = exports.overlayClass = exports.sheetClass = void 0;
const nano_theme_1 = require("nano-theme");
exports.sheetClass = (0, nano_theme_1.drule)({
    pos: 'fixed',
    left: 0,
    right: 0,
    bottom: '8px',
    marginInline: 'auto',
    width: 'fit-content',
    maxWidth: '560px',
    d: 'flex',
    flexDirection: 'column',
    bdrad: '14px',
    out: 'none',
    ov: 'hidden',
    zIndex: 9999,
    maxHeight: 'calc(100vh - 24px)',
});
exports.overlayClass = (0, nano_theme_1.rule)({
    pos: 'fixed',
    inset: 0,
    bg: 'rgba(0, 0, 0, .35)',
    zIndex: 9998,
});
exports.handleAreaClass = (0, nano_theme_1.rule)({
    d: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pad: '8px 0 4px',
    flexShrink: 0,
});
exports.paneClass = (0, nano_theme_1.drule)({
    pos: 'relative',
    d: 'flex',
    flexDirection: 'column',
    flex: 1,
    ov: 'hidden',
});
exports.headerClass = (0, nano_theme_1.drule)({
    d: 'flex',
    alignItems: 'center',
    gap: '8px',
    pad: '6px 12px',
    minHeight: '44px',
    bxz: 'border-box',
    flexShrink: 0,
    bdb: '1px solid transparent',
});
exports.headerTitleClass = (0, nano_theme_1.drule)({
    flex: 1,
    d: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ta: 'center',
    fz: '15px',
    fw: 600,
    ov: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
});
exports.listClass = (0, nano_theme_1.drule)({
    flex: 1,
    ov: 'auto',
    WebkitOverflowScrolling: 'touch',
    overscrollBehavior: 'contain',
    pad: '4px 0 16px',
});
exports.itemRowClass = (0, nano_theme_1.drule)({
    d: 'flex',
    alignItems: 'center',
    width: '320px',
    bxz: 'border-box',
    pad: '12px 16px',
    bd: 0,
    bg: 'transparent',
    out: 'none',
    ta: 'start',
    cur: 'pointer',
    fz: '15px',
    minHeight: '48px',
    '&:active': {
        bg: 'rgba(127,127,127,.16)',
    },
});
exports.itemIconClass = (0, nano_theme_1.rule)({
    d: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    w: '24px',
    h: '24px',
    marginInlineEnd: '14px',
    flexShrink: 0,
});
exports.itemMainClass = (0, nano_theme_1.rule)({
    flex: 1,
    d: 'flex',
    flexDirection: 'column',
    minWidth: 0,
});
exports.itemLabelClass = (0, nano_theme_1.rule)({
    ov: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
exports.itemDescriptionClass = (0, nano_theme_1.drule)({
    fz: '12px',
    marginTop: '2px',
    ov: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
exports.itemRightClass = (0, nano_theme_1.rule)({
    marginInlineStart: '12px',
    d: 'flex',
    alignItems: 'center',
    flexShrink: 0,
});
exports.itemKeysClass = (0, nano_theme_1.drule)({
    marginInlineStart: '12px',
    d: 'flex',
    gap: '4px',
    flexShrink: 0,
    fz: '11px',
});
exports.keyChipClass = (0, nano_theme_1.drule)({
    d: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    pad: '2px 6px',
    bdrad: '4px',
    fz: '11px',
});
exports.chevronClass = (0, nano_theme_1.rule)({
    marginInlineStart: '8px',
    d: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    op: 0.5,
});
exports.sectionTitleClass = (0, nano_theme_1.drule)({
    pad: '14px 16px 6px',
    fz: '12px',
    fw: 600,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
});
exports.separatorClass = (0, nano_theme_1.drule)({
    h: '1px',
    mar: '6px 0',
});
exports.visuallyHiddenClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    w: '1px',
    h: '1px',
    pad: 0,
    mar: '-1px',
    ov: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    bd: 0,
});
